import script from "./ResidentDashboardDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./ResidentDashboardDetailView.vue?vue&type=script&setup=true&lang=js"

import "./ResidentDashboardDetailView.vue?vue&type=style&index=0&id=7da16de4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7da16de4"]])

export default __exports__